"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "copyright",
    style: _vm.customStyle
  }, [_vm._v("© " + _vm._s(_vm.curYear) + " " + _vm._s(_vm.text))]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;